"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _AccountCircle = _interopRequireDefault(require("@tvg/fuse-icons/lib/AccountCircle"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledIconButton = require("./styled-icon-button");
var _excluded = ["dataTestId", "disabled", "text", "notification"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var propTypes = {
  href: _propTypes["default"].string.isRequired,
  text: _propTypes["default"].string.isRequired,
  dataTestId: _propTypes["default"].string,
  notification: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  icon: _propTypes["default"].element,
  size: _propTypes["default"].string
};
var defaultProps = {
  dataTestId: null,
  disabled: false,
  icon: /*#__PURE__*/_react["default"].createElement(_AccountCircle["default"], null),
  notification: undefined,
  size: 'Large'
};
function Component(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var dataTestId = props.dataTestId,
    disabled = props.disabled,
    text = props.text,
    notification = props.notification,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledIconButton.StyledIconButton, _extends({
    className: "fuse-icon-button",
    "aria-label": notification ? "".concat(notification, " notification in ").concat(text) : undefined,
    as: disabled ? 'button' : '',
    "data-testid": dataTestId,
    disabled: disabled
  }, other), notification && /*#__PURE__*/_react["default"].createElement("span", {
    className: "fuse-icon-button__notification notification"
  }, notification), /*#__PURE__*/_react["default"].createElement("span", {
    className: "fuse-icon-button__text"
  }, text));
}
Component.propTypes = propTypes;
Component.defaultProps = defaultProps;
var _default = exports["default"] = Component;